import React from 'react';
import type { NPC, DialogOption } from '../../../../shared/NPCData';
import { TomeButton, TomeChapter, TomeEntry } from '../../primitives/tome';

interface ServicesViewProps {
  npc: NPC;
  npcTypeInfo: { color: string; icon: string; name: string };
  onDialogSelect?: (option: DialogOption) => void;
  playerGold: number;
}

/** Legacy services stay compatible; structured ability training has its own quoted view. */
export const ServicesView: React.FC<ServicesViewProps> = ({ npc, onDialogSelect, playerGold }) => (
  <TomeChapter title="Services" className="npc-services">
    {npc.services.map((service, index) => {
      const validCost = Number.isFinite(service.cost) && service.cost >= 0;
      const affordable = validCost && playerGold >= service.cost;
      const training = service.action.startsWith('learnAbility:');
      return <TomeEntry className="npc-service-card" key={`${service.action}-${index}`} aria-label={service.name}
        title={service.name} tone={affordable ? 'available' : 'default'}>
        <p className="npc-service-description">{service.description}</p>
        <div className="npc-card-action-row">
          <span className="npc-quoted-price">{validCost ? (service.cost === 0 ? 'Free' : `${service.cost.toLocaleString()} Gold`) : 'Price unavailable'}</span>
          <TomeButton tone="primary" disabled={!affordable || !onDialogSelect}
            onClick={() => affordable && onDialogSelect?.({ text: `Use ${service.name}`, icon: service.icon, action: service.action })}>
            {!affordable && validCost ? `Need ${service.cost.toLocaleString()} Gold` : `${training ? 'Train' : 'Use'} ${service.name}`}
          </TomeButton>
        </div>
      </TomeEntry>;
    })}
  </TomeChapter>
);
